import React from 'react';
import ViewReverse from '../../components/ViewReverse';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import Button from '../../components/Button';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { number_regix } from '../../utils/functions';
import SarSymbol from '../../components/SarSymbol';
import TopupFunctional from './index.function';
import ViewItems from '../../components/ViewItems';
import LoaderModal from '../../components/LoaderModal';

const TopUp = () => {
  const {
    getContentKey,
    TextWeight,
    clientDetails,
    amount,
    setAmount,
    PaymentFormSubmitter,
    isArabic,
    navigate,
    error,
    setError,
    investmentLoading,
    initiate_payment_loading,
  } = TopupFunctional();

  return (
    <div>
      <ViewReverse className='items-center gap-4'>
        <ReactSVG src={icons.backSmall} className='   cursor-pointer' onClick={() => navigate(-1)}
          style={{ transform: isArabic ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
        <Text text={getContentKey('topup')} size={fontSizes.h18} weight={TextWeight.bold} />
      </ViewReverse>

      <ViewItems className={'border mt-6 border-grey px-5 pt-6 pb-4 shadow-light rounded-xl w-full'}>
        <Text size={fontSizes.h16} className={'mb-1'} text={getContentKey('enter_amount')} weight={TextWeight.semiBold} />
        <ViewReverse isReverse={false} className={`items-center ${isArabic ? 'self-end' : 'self-start'} gap-2 border rounded-lg md:w-2/5 px-2 py-1`}>
          <SarSymbol size={fontSizes.h24} color={'text-black'} />
          <input
            value={amount}
            placeholder='0.00'
            maxLength={8}
            onChange={(e) => {
              let val = e.target.value;
              const cleanedText = val?.replace(/^0+/, '');
              const isNumber = number_regix.test(cleanedText);
              if (isNumber && Number(cleanedText) > 0) {
                if (Number(cleanedText) > 20000000) {
                  setError(getContentKey('amount_validation'));
                } else {
                  setError("");
                }
                setAmount(cleanedText);
              } else if (cleanedText === '') {
                setAmount('');
                setError('');
              }
            }}
            className={`outline-none text-base font-bold ${isArabic ? 'almarai-regular' : 'shubbak-regular'}`}
          />
        </ViewReverse>
        {error?.length > 0 ? <Text text={error} color='text-red' size={fontSizes.h14} className={'mt-1'} /> : null}

        <Text size={fontSizes.h16} className={'mt-8'} text={getContentKey('send_to')} weight={TextWeight.semiBold} />

        <ViewReverse>
          <ViewReverse className={'bg-yellow p-3.5 rounded-lg mt-2 w-full md:w-2/5 justify-between items-center'}>
            <div>
              <Text text={getContentKey('checking_account')} color='text-white' size={fontSizes.h14} weight={TextWeight.semiBold} />
              <Text text={clientDetails?.cashAccountList?.[0]?.accountInformation?.cashAccount} color='text-white' size={fontSizes.h14} />
            </div>
            {/* <ReactSVG src={icons.backSmallWhite} className='rotate-180' /> */}
          </ViewReverse>
        </ViewReverse>

        <ViewReverse>
          <Button
            text={getContentKey('continue')}
            className={'w-full md:w-2/5 mt-7 capitalize'}
            onClick={PaymentFormSubmitter}
            isDisabled={!amount || amount < 1 || error?.length > 0}
            loading={initiate_payment_loading}
          />
        </ViewReverse>
      </ViewItems>

      <LoaderModal open={investmentLoading} />
    </div>
  );
};

export default TopUp;
